var _g, _mask, _g2, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPcloudyN(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 459,
    height: 408,
    fill: "none",
    viewBox: "0 0 459 408",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_30_551)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_linear_30_551)",
    fillRule: "evenodd",
    d: "M291.835 1.93083C282.351 0.658022 272.661 0 262.811 0C147.913 0 54.7692 89.5431 54.7692 200C54.7692 310.457 147.913 400 262.811 400C349.227 400 423.337 349.349 454.769 277.244C452.741 277.303 450.705 277.333 448.662 277.333C343.721 277.333 258.65 198.535 258.65 101.333C258.65 64.4492 270.899 30.2152 291.835 1.93083Z",
    clipRule: "evenodd"
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_30_551",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M280.172 360L131.742 360C58.983 360 0 299.558 0 225C0 150.442 58.983 90 131.742 90C190.248 90 239.846 129.08 257.034 183.156C264.406 181.098 272.164 180 280.172 180C328.678 180 368 220.294 368 270C368 319.706 328.678 360 280.172 360Z",
    clipRule: "evenodd"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_30_551)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint1_linear_30_551)",
    fillRule: "evenodd",
    d: "M280.172 360L131.742 360C58.983 360 0 299.558 0 225C0 150.442 58.983 90 131.742 90C190.248 90 239.846 129.08 257.034 183.156C264.406 181.098 272.164 180 280.172 180C328.678 180 368 220.294 368 270C368 319.706 328.678 360 280.172 360Z",
    clipRule: "evenodd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.05,
    d: "M131.742 360V359V360ZM280.172 360V361V360ZM257.034 183.156L256.081 183.459L256.373 184.379L257.303 184.119L257.034 183.156ZM131.742 361L280.172 361V359L131.742 359V361ZM-1 225C-1 300.087 58.4078 361 131.742 361V359C59.5582 359 1 299.029 1 225H-1ZM131.742 89C58.4078 89 -1 149.912 -1 225H1C1 150.971 59.5582 91 131.742 91V89ZM257.987 182.853C240.676 128.388 190.71 89 131.742 89V91C189.787 91 239.017 129.773 256.081 183.459L257.987 182.853ZM257.303 184.119C264.588 182.086 272.255 181 280.172 181V179C272.072 179 264.223 180.111 256.765 182.193L257.303 184.119ZM280.172 181C328.103 181 367 220.823 367 270H369C369 219.765 329.253 179 280.172 179V181ZM367 270C367 319.176 328.103 359 280.172 359V361C329.253 361 369 320.235 369 270H367Z",
    mask: "url(#path-2-inside-1_30_551)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_30_551",
    width: 429,
    height: 415,
    x: 29.769,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "effect1_dropShadow_30_551"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_30_551",
    mode: "normal",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -25,
    dy: 15
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.607843 0 0 0 0 0.529412 0 0 0 0 0.921569 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    mode: "normal",
    result: "effect2_innerShadow_30_551"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_30_551",
    width: 368,
    height: 318.647,
    x: 0,
    y: 90,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 48.647
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 30
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    mode: "normal",
    result: "effect1_innerShadow_30_551"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_30_551",
    x1: 78.347,
    x2: 362.684,
    y1: 0,
    y2: 466.144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B87EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.659,
    stopColor: "#3010AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_30_551",
    x1: 25.78,
    x2: 374.314,
    y1: 90,
    y2: 351.735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1C1C1"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPcloudyN);
export default __webpack_public_path__ + "static/media/pcloudyN.8b7460a135e4b7cbae610f34abe3a6b4.svg";
export { ForwardRef as ReactComponent };